import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Menu,
  MenuItem
} from '@material-ui/core'
import { CornerUpLeftIcon, DeleteIcon, SmileIcon } from 'lucide-react'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useStyles } from './style'
import { toast } from 'react-toastify'
import api from '../../services/api'
import { ButtonSecondary } from '../ButtonSecondary'
import { ButtonPrimary } from '../ButtonPrimary'

const ChatMessageActionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  onReplyMessage,
  onOpenReactionsMenu,
  onMessageDeleted
}) => {
  const classes = useStyles()
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)

  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true)
    // closeMainMenu()
  }

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false)
  }

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false)
    if (!message || !message.id || !message.chatId) {
      closeMainMenu()
      return
    }

    try {
      await api.delete(`/chats/${message.chatId}/messages/${message.id}`)
      toast.success('Mensagem deletada com sucesso!')
      onMessageDeleted(message.id)
      closeMainMenu()
    } catch (err) {
      if (err.response?.status === 404) {
        toast.error('Mensagem não encontrada no servidor.')
      } else if (err.response?.status === 500) {
        toast.error('Erro interno no servidor. Tente novamente mais tarde.')
      } else {
        toast.error('Erro ao deletar mensagem.')
      }
      closeMainMenu()
    }
  }

  const closeMainMenu = () => {
    handleClose()
  }

  const handleReplyMessage = () => {
    if (!message) {
      console.error('Mensagem não encontrada para responder')
      closeMainMenu()
      return
    }
    onReplyMessage(message)
    closeMainMenu()
  }

  const handleDeleteMessage = () => {
    handleOpenConfirmDialog()
  }

  const handleOpenReactionsMenu = event => {
    event.preventDefault()
    event.stopPropagation()

    const rect = event.currentTarget.getBoundingClientRect()
    const menuPosition = {
      mouseX: rect.right + 10,
      mouseY: rect.top - 5
    }
    onOpenReactionsMenu(menuPosition, message)
    closeMainMenu()
  }

  return (
    <>
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="confirm-delete-dialog-title"
        aria-describedby="confirm-delete-dialog-description"
        maxWidth="xs"
      >
        <DialogTitle id="confirm-delete-dialog-title">
          {'Confirmar Deleção'}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="confirm-delete-dialog-description">
            Deseja realmente deletar esta mensagem? Esta ação não pode ser
            desfeita.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonSecondary
            onClick={handleCloseConfirmDialog}
            label="Cancelar"
          />
          <ButtonPrimary
            onClick={handleConfirmDelete}
            color="secondary"
            autoFocus
            label="Excluir"
          />
        </DialogActions>
      </Dialog>

      <Menu
        keepMounted
        className={classes.menu}
        open={menuOpen}
        onClose={closeMainMenu}
        anchorReference="anchorPosition"
        anchorPosition={
          anchorEl !== null
            ? { top: anchorEl.mouseY, left: anchorEl.mouseX }
            : undefined
        }
        elevation={0}
      >
        <MenuItem onClick={handleReplyMessage} className={classes.menuItem}>
          <CornerUpLeftIcon size={18} />
          Responder
        </MenuItem>

        <MenuItem
          onClick={handleOpenReactionsMenu}
          className={classes.menuItem}
        >
          <SmileIcon size={18} />
          Reagir
        </MenuItem>
        <MenuItem onClick={handleDeleteMessage} className={classes.menuItem}>
          <DeleteIcon size={18} />
          Deletar
        </MenuItem>
      </Menu>
    </>
  )
}

ChatMessageActionsMenu.propTypes = {
  message: PropTypes.object.isRequired,
  menuOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.object,
  onReplyMessage: PropTypes.func.isRequired,
  onOpenReactionsMenu: PropTypes.func.isRequired,
  onMessageDeleted: PropTypes.func.isRequired
}

export default ChatMessageActionsMenu
